import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';

var Cliente = Object.create(DatabaseModel);

Cliente.model = 'cliente';
Cliente.modelFront = 'clientes';

Cliente.importar = function(documento) {
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/importar/',
        method: 'POST',
        data: documento
    };
    return self.sendRequest(params, false).then((res) => {
        CacheService.clearCache(self.model);
        return res;
    }).catch((error) => {
        var message = typeof error == "string" ? error : error.message;
        app.dialog.alert(message);
    });
}

// Cuántos clientes están sin responsable de gestión de cobro (#205). Se le pasa EL MISMO filtro
// que la consulta acaba de usar, para que el número corresponda a lo que hay en pantalla. Sin
// caché (`false`): el recuento se pide justo después de cada carga y de cada asignación, y una
// respuesta guardada enseñaría el número de antes de asignar.
//
// Y con LA MISMA proyección, que va por la URL igual que en el `search`. No es un adorno: media
// docena de columnas de esta consulta —«Provincia Social» y las otras de dirección social— filtran
// por un campo que no existe en los documentos de cliente y que el backend materializa en una etapa
// del pipeline que solo se añade si se pide esa proyección. Sin ella, filtrando por una provincia la
// tabla enseña filas y el recuento diría cero.
Cliente.recuentoGestionCobro = function (params) {
    const self = this;
    const opciones = params || {};
    const query = opciones.projection ? '?projection=' + encodeURIComponent(opciones.projection) : '';
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/recuento-gestion-cobro' + query,
        method: 'POST',
        data: opciones.filter || {}
    }, false);
}

Cliente.enviarBC = function (params) {
    var self = this;
    return new Promise(function (resolve, reject) {
        if (!params.itemId) reject({ error: 'itemId not defined' });
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/enviarBC/' + params.itemId,
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: params.data
        }).then(function ({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data.dto);
            }
        }).catch(function ({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}
Cliente.getCuentas = function (params) {
    var self = this;
    return new Promise(function (resolve, reject) {
        if (!params.itemId) reject({ error: 'itemId not defined' });
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/cuentas/' + params.itemId,
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: params.data
        }).then(function ({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch(function ({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
}

export default Cliente;